import React, { useEffect } from "react";
import InstagramAccountSwitcher from "./InstagramAccountSwitcher";
import { useLayout } from "../../CustomHooks.js/LayoutContext";
import { Outlet } from "react-router";

function InstagramWrapper({ children }) {
  const { setLayoutComponent, clearLayoutComponent } = useLayout();

  useEffect(() => {
    setLayoutComponent(InstagramAccountSwitcher);
    return () => {
      clearLayoutComponent();
    };
  }, []);
  return (
    <div style={{ height: "100%" }}>
      <Outlet />
    </div>
  );
}

export default InstagramWrapper;
